import * as qs from 'qs'

import { weixinShare, wxConfigReady } from '@ivy/fts/weixin'

import { appGolbal } from '@ivy/fts/appGlobal'
import conf from './config'
import html2canvas from 'html2canvas'
import { sleep } from '@ivy/fts/utils'

/**
 * 根据window.devicePixelRatio获取像素比
 */
function DPR() {
  if (window.devicePixelRatio && window.devicePixelRatio > 1) {
    return window.devicePixelRatio
  }
  return 1
}
/**
 * 将传入值转为整数
 */
function parseValue(value) {
  return parseInt(value, 10)
}
export function trackEventToYoumeng(a, b, c) {
  // conf.env === 'production' && trackEvent(a, b, c)
}
export async function drawCanvas(dom) {
  // 获取想要转换的 DOM 节点
  let box = window.getComputedStyle(dom)
  // DOM 节点计算后宽高
  let width = parseValue(box.width)
  let height = parseValue(box.height)
  // 获取像素比
  let scaleBy = DPR()
  // 创建自定义 canvas 元素
  let canvas = document.createElement('canvas')

  // 设定 canvas 元素属性宽高为 DOM 节点宽高 * 像素比
  canvas.width = width * scaleBy
  canvas.height = height * scaleBy
  // 设定 canvas css宽高为 DOM 节点宽高
  canvas.style.width = `${width}px`
  canvas.style.height = `${height}px`
  // 获取画笔
  const context = canvas.getContext('2d')

  // 将所有绘制内容放大像素比倍
  context.scale(scaleBy, scaleBy)

  // 将自定义 canvas 作为配置项传入，开始绘制
  return await html2canvas(dom, { canvas, useCORS: true })
}
export async function setShare(opt) {
  await wxConfigReady()
  await weixinShare(opt)
}

// 验证手机号
export function checkPhone(phone) {
  return /^1[345678]\d{9}$/.test(phone)
}

// 验证验证码
export function checkCode(code) {
  return /^\d{4}$/.test(code)
}

// 阿里云图片获取指定尺寸的图片
export function transAliImgResize(url, width, height, mode = 'mfit') {
  // return igorePrefex(`${url}?x-oss-process=image/resize,m_${mode},h_${height},w_${width}`)
  return `${url}?x-oss-process=image/resize,m_${mode},h_${height},w_${width}`
}

// 去掉网络协议请求头
export function igorePrefex(url) {
  return url.replace(/https?:(\/\/.+\.)/, '$1')
}

//  * 获取数据类型
//  * getType(5); // => "Number"
//  * getType({}); // => "Object"
//  * getType(/foo/); // => "RegExp"
//  * getType(''); // => "String"
//  * getType(true); // => "Boolean"
//  * getType([]); // => "Array"
//  * getType(undefined); // => "Window"
//  * getType(Element); // => "Constructor"
export function getType(object) {
  return Object.prototype.toString.call(object).match(/^\[object\s(.*)\]$/)[1]
}

export async function getAppInfo() {
  await sleep(50)
  let all = await appGolbal.nativeGetInfo('all')
  if (typeof all === 'string') {
    all = JSON.parse(all)
  }
  return all
}

// 隐藏微信右上角分享的复制链接
export async function hideWxShareItems() {
  await wxConfigReady()
  let hidelist = [
    'menuItem:share:qq', // 分享到QQ
    'menuItem:favorite', // 收藏
    'menuItem:share:weiboApp', // 分享到微博
    'menuItem:share:facebook', // 分享到FaceBook
    'menuItem:share:QZone', // 分享到QQ空间
    'menuItem:openWithQQBrowser', // 在QQ浏览器打开
    'menuItem:openWithSafari', // 在safari中打开
    'menuItem:copyUrl', // 复制链接
    'menuItem:originPage', // 原网页
    'menuItem:share:email', // 邮件
    'menuItem:share:brand', // 一些特殊公众号
  ]

  window.wx &&
    window.wx.hideMenuItems({
      menuList: hidelist,
    })
}

/**
 * 设置页面标题。
 * iOS Safari / 微信内置浏览器在 SPA 客户端路由切换时，动态修改 document.title
 * 不会刷新导航栏可视标题。通过插入一个临时 iframe 触发 WebView 重新读取标题。
 */
export function setDocumentTitle(title: string) {
  document.title = title
  if (/iphone|ipad|ipod|ios/i.test(navigator.userAgent)) {
    const iframe = document.createElement('iframe')
    iframe.style.display = 'none'
    iframe.src = '/favicon.ico'
    const onload = () => {
      setTimeout(() => {
        iframe.removeEventListener('load', onload)
        iframe.parentNode && iframe.parentNode.removeChild(iframe)
      }, 0)
    }
    iframe.addEventListener('load', onload)
    document.body.appendChild(iframe)
  }
}

/**
 * 格式化价格/金额：去掉无意义的小数点和末尾的 0。
 * 例：'0.00' → '0'，'100.00' → '100'，'99.50' → '99.5'。
 * 非数字时原样返回。
 */
export function formatAmount(value: string | number): string {
  if (value === null || value === undefined || value === '') return ''
  const n = Number(value)
  return isNaN(n) ? String(value) : String(n)
}
